module.exports = __webpack_public_path__ + "static/media/bindQQ1.ab328760.png";